import { useCallback, useMemo } from 'react';
import { StandaloneUsageTracker } from '../utils/usageTracker';
import { useStudioOptinContext } from '../components/studio/MarketingStudioOptinWrapper';
export default function useTrackCampaignSelectInteraction({
  applicationId,
  enableTracking,
  handleCampaignAutoSelectChange,
  handleSelectedOptionChange,
  assetObjectType,
  numberOfObjectsToAssociate
}) {
  const {
    hasAccessToMarketingStudio
  } = useStudioOptinContext();
  const trackCampaignSelection = useCallback(trackingProps => {
    const timesToTrack = numberOfObjectsToAssociate || 1;
    for (let i = 0; i < timesToTrack; i++) {
      StandaloneUsageTracker.track('Campaigns Lib', 'Campaign Select Interaction', Object.assign({}, trackingProps, hasAccessToMarketingStudio && {
        deployableName: 'marketing-studio-ui'
      }));
    }
  }, [numberOfObjectsToAssociate, hasAccessToMarketingStudio]);
  const handleCampaignAutoSelectChangeWithTracking = useCallback(campaignToAutoSelect => {
    if (campaignToAutoSelect) {
      const campaignValue = Array.isArray(campaignToAutoSelect) ? campaignToAutoSelect[0] : campaignToAutoSelect;
      if (campaignValue) {
        trackCampaignSelection({
          action: 'auto select a campaign',
          applicationId,
          campaignId: campaignValue.guid,
          assetId: campaignValue.objectId,
          assetType: assetObjectType
        });
      }
    }
    return handleCampaignAutoSelectChange(campaignToAutoSelect);
  }, [applicationId, handleCampaignAutoSelectChange, assetObjectType, trackCampaignSelection]);
  const handleSelectedOptionChangeWithTracking = useCallback(event => {
    const {
      value
    } = event.target;
    if (value) {
      const campaignValue = Array.isArray(value) ? value[0] : value;
      const containsSearchQuery = Array.isArray(value) ? value.some(val => val.containsSearchQuery) : Boolean(value.containsSearchQuery);
      const isRecentlyUsed = Array.isArray(value) ? value.some(val => val.isRecentlyUsed) : Boolean(value.isRecentlyUsed);
      trackCampaignSelection({
        action: 'select a campaign',
        applicationId,
        containsSearchQuery,
        isRecentlyUsed,
        campaignId: campaignValue === null || campaignValue === void 0 ? void 0 : campaignValue.guid,
        assetId: campaignValue === null || campaignValue === void 0 ? void 0 : campaignValue.objectId,
        assetType: assetObjectType
      });
    }
    return handleSelectedOptionChange(event);
  }, [applicationId, handleSelectedOptionChange, assetObjectType, trackCampaignSelection]);
  return useMemo(() => {
    if (enableTracking) {
      return {
        handleCampaignAutoSelectChangeWithTracking,
        handleSelectedOptionChangeWithTracking,
        trackCampaignSelection
      };
    }
    return {
      handleCampaignAutoSelectChangeWithTracking: handleCampaignAutoSelectChange,
      handleSelectedOptionChangeWithTracking: handleSelectedOptionChange,
      trackCampaignSelection: () => {}
    };
  }, [enableTracking, handleCampaignAutoSelectChange, handleCampaignAutoSelectChangeWithTracking, handleSelectedOptionChange, handleSelectedOptionChangeWithTracking, trackCampaignSelection]);
}